import { Validations } from './types';

export function createFieldValidation(id: string, value?: string): Validations {
  switch (id) {
    case 'required':
      return { isRequired: true };
    case 'readonly':
      return { isReadonly: true };
    case 'multi':
      return { isMulti: true };
    case 'min':
      return { minimumNumber: Number(value) };
    case 'max':
      return { maximumNumber: Number(value) };
    case 'minlength':
      return { minimumLength: Number(value) };
    case 'maxlength':
      return { maximumLength: Number(value) };
    case 'file':
      return { isFile: true };
    case 'dataList':
      return { dataListName: value };
    case 'slList':
      return { slList: true };
    case 'execList':
      return { execList: true };
    case 'mask':
      return { mask: value };
    case 'pattern':
      return { pattern: value };
    case 'conditionalInput':
      return { conditionalInput: value };
    case 'conditionalValue':
      return { conditionalValue: value };
    case 'conditionalAction':
      return { conditionalAction: value };
    case 'dynamicTableName':
      return { dynamicTableName: value };
    case 'dynamicButton':
      return { dynamicButton: value };
    default:
      return {};
  }
}
